module.exports = __webpack_public_path__ + "static/media/upgrade-graph.eafb3f22.png";